import classNames from 'classnames'

import { stopPropagation } from '../../../utils/events'
import { toCSSPixel } from '../../../utils/styles'

import { checkIsTableRowFocused } from './TableRowContextActionsContainer.utils'

import * as styles from './TableRowContextActionsContainer.module.css'

function TableRowContextActionsContainer({
  Component,
  actionLeft,
  checkIsRowFocused = checkIsTableRowFocused,
  className = styles.TableRowContextActionsContainer,
  componentItemClassName = styles.componentItem,
  focusedRow,
  item,
  ...restProps
}) {
  function handleClick(event) {
    stopPropagation(event)
  }

  const componentClassName = classNames(componentItemClassName, {
    [styles.focused]: checkIsRowFocused(item, focusedRow),
  })

  return (
    <div
      className={className}
      style={{
        left: toCSSPixel(actionLeft),
      }}
      onClick={handleClick}
    >
      <Component {...restProps} className={componentClassName} item={item} />
    </div>
  )
}

export default TableRowContextActionsContainer
